export default "__VITE_ASSET__DmVP6ANU__"